import {useMemo, useEffect, useCallback} from 'react'
import styled from 'styled-components'
import {useDispatch} from 'redux-react-hook'
import {Card, CardHeader, Flex} from '@binance/uikit'
import DepthChart from 'components/TradeView/Graph/VerticalDepthChart'
import {scale as scaleAction} from 'actions'
import useScale from 'hooks/useScale'
import storge from 'utils/localStorage'

const Title = styled.span`
  font-weight: 500;
  font-size: 13px;
  line-height: 17px;
`

export default function DepthChartView ({i18n}) {
  const dispatch = useDispatch()
  const scale = useScale()
  const handleScaleChange = useCallback(
    e => {
      const v = e.target.value
      storge.setItem('scale', v)
      dispatch(scaleAction(v))
    },
    [dispatch]
  )

  useEffect(() => {
    const v = storge.getItem('scale')
    dispatch(scaleAction(Number(v) || 0))
  }, [dispatch])

  return useMemo(
    () => (
      <Card gridArea="depthchart" className="vertical-depth-chart">
        <CardHeader>
          <Flex flex={1} justifyContent="space-between" alignItems="center">
            <Title> {i18n['graph-depth'] || 'Depth'} </Title>
            <input type="range" min={0} max={1000} value={scale} onChange={handleScaleChange} />
          </Flex>
        </CardHeader>
        <DepthChart scale={scale} />
      </Card>
    ),
    [handleScaleChange, i18n, scale]
  )
}
